import React from 'react';

import Typography from '@/components/typography';

type Props = {
  description: string;
  source?: string;
};

/** JSX for the hover content of an insights layer tooltip */
const InsightsMoreInfoToolTip: React.FC<Props> = ({
  description,
  source = undefined,
}) => {
  return (
    <div className="flex flex-col gap-y-2">
      <Typography className="text-white" variant="body1">
        {description}
      </Typography>
      {source && (
        <Typography className="text-white" variant="caption">
          Source: {source}
        </Typography>
      )}
    </div>
  );
};

export default InsightsMoreInfoToolTip;
